import { useContext } from 'react';
import { CheckoutGiftSectionMessageContext } from './CheckoutGiftSectionMessageProvider';

export const useCheckoutGiftSectionMessageContext = () =>
  useContext(CheckoutGiftSectionMessageContext);
